module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c0GTW"))).then(() => parcelRequire('1iHdE'));